var React = require('react');

function FinancialsDollar12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.0009 1.17102L4 0H2L2.00009 1.17067C0.83485 1.58249 0 2.69375 0 4C0 5.65685 1.34315 7 3 7L3.11662 7.00673C3.61396 7.06449 4 7.48716 4 8C4 8.55229 3.55228 9 3 9C2.44772 9 2 8.55229 2 8H0L0.00509269 8.17627C0.0763156 9.4055 0.887636 10.4362 2.00009 10.8293L2 12H4L4.0009 10.829C5.16562 10.4169 6 9.30588 6 8C6 6.34315 4.65685 5 3 5L2.88338 4.99327C2.38604 4.93551 2 4.51284 2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4H6L5.99491 3.82373C5.92371 2.59487 5.11285 1.56444 4.0009 1.17102ZM10 11V9H7V11H10ZM12 5V7H7V5H12ZM12 3V1H7V3H12Z","fill":"currentColor"}));
}

FinancialsDollar12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = FinancialsDollar12;

FinancialsDollar12.default = FinancialsDollar12;
